module.exports = Object.freeze({
    SUPPLIES_ARMIES: [
        '2 2',
        '3 2',
        '3 2 2',
        '3 2 2 2',
        '3 3 2 2',
        '4 3 2 2',
        '4 3 2 2 2'
    ],
    HOUSES_PROPERTIES: [
        // Stark
        {
            PRIMARY_COLOR: '#FEF5CC',
            SECONDARY_COLOR: '#9D9F9E'
        },
        // Lannister
        {
            PRIMARY_COLOR: '#A01830',
            SECONDARY_COLOR: '#FCE468'
        },
        // Greyjoy
        {
            PRIMARY_COLOR: '#101006',
            SECONDARY_COLOR: '#FFD147'
        },
        // Martell
        {
            PRIMARY_COLOR: '#F38C01',
            SECONDARY_COLOR: '#872921'
        },
        // Tyrell
        {
            PRIMARY_COLOR: '#9BB693',
            SECONDARY_COLOR: '#F8CF5B'
        },
        // Baratheon
        {
            PRIMARY_COLOR: '#FCB600',
            SECONDARY_COLOR: '#AF7F00'
        },
        // Arryn
        {
            PRIMARY_COLOR: '#002B4B',
            SECONDARY_COLOR: '#F4F7D8'
        },
        // Targaryen
        {
            PRIMARY_COLOR: '#101006',
            SECONDARY_COLOR: '#A11730'
        }
    ],
    MAX_ROUND: 10,
    MAX_CASTLES: 7,
    MAX_INFLUENCE: 7,
    MAX_WILDLING_THREAT: 12
});
